export const LOGIN_USER_FAIL = "login_user_fail";
export const LOGIN_USER_SUCCESS = "login_user_success";
export const SEND_SUCCESS_LOGIN_FEEDBACK = "send_success_login_feedback";
export const UPDATE_HEADER_INFO = "update_header_info";
export const GET_DECKS = "get_decks";
export const GET_DECKS_FAILED = "get_decks_failed";
export const EDIT_DECK = "edit_deck";
export const EDIT_DECK_FAILED = "edit_deck_failed";
export const ADD_QUESTION_TO_DECK = "add_question_to_deck";
export const ADD_QUESTION_TO_DECK_FAILED = "add_question_to_deck_failed";
export const CREATE_DECK = "create_deck";
export const CREATE_DECK_FAILED = "create_deck_failed";
export const GET_QUESTION = "get_question";
export const GET_QUESTION_FAILED = "get_question_failed";
export const GET_SKIP_QUESTION = "get_skip_question";
export const GET_SKIP_QUESTION_FAILED = "get_skip_question_failed";
export const GET_QUESTION_RESULTS = "get_question_results";
export const GET_QUESTION_RESULTS_FAILED = "get_question_results_failed";
export const PUT_RESPONSE = "put_response";
export const PUT_RESPONSE_FAILED = "put_response_failed";
export const PUT_NEXT_REVIEW_RESPONSE = "put_next_review_response";
export const PUT_NEXT_REVIEW_RESPONSE_FAILED = "put_next_review_response_failed";
export const DEREGISTER = "deregister";
export const DEREGISTER_FAILED = "deregister_failed";
export const GET_USER_DETAILS = "get_user_details";
export const GET_USER_DETAILS_FAILED = "get_user_details_failed";
export const CME_CONFIRMATION = "cme_confirmation";
export const CME_CONFIRMATION_FAILED = "cme_confirmation_failed";
export const FETCH_AVAILABLE_QUESTIONS = "fetch_available_questions";
export const FETCH_AVAILABLE_QUESTIONS_FAILED = "fetch_available_questions_failed";
export const GET_QUESTION_COUNT = "get_question_count";
export const GET_QUESTION_COUNT_FAILED = "get_question_count_failed";
export const UPDATE_FOOTER_INFO = "update_footer_info";
export const LOGOUT_SUCCESS = "logout_success";
export const LOGOUT_FAILURE = "logout_failure";
export const GET_PUBLIC_DECKS = 'get_public_decks';
export const GET_PUBLIC_DECKS_FAILED = 'get_public_decks_failed';
export const COPY_DECKS = 'set_public_decks';
export const COPY_DECKS_FAILED = 'set_public_decks_failed';
export const UPDATE_PROFILE = 'update_profile';
export const UPDATE_PROFILE_FAIL = 'update_profile_fail';
export const ADD_NOTE_TO_DECK_FAILED = 'add_note_to_deck_failed';
export const ADD_NOTE_TO_DECK = 'add_note_to_deck'; 
export const ADD_NOTE_TO_QUESTION_FAILED = 'add_note_to_question_failed';
export const ADD_NOTE_TO_QUESTION = 'add_note_to_question'; 
export const SASP_LEADREBOARD = 'sasp_leaderboard';
export const SASP_LEADREBOARD_FAILED = 'sasp_leaderboard_failed';
export const GET_DEVICE_DATA = 'device_data';
export const GET_DEVICE_DATA_FAILED = 'device_data_failed';
export const SHARE_USERS = 'share_users';
export const SHARE_USERS_FAILED = 'share_users_failed';
export const SEARCH_USERS = 'search_users';
export const SEARCH_USERS_FAILED = 'search_users_failed';
export const SHARE_DECKS = 'share_decks';
export const SHARE_DECKS_FAILED = 'share_decks_failed';
export const EMAIL_RESULTS = 'email_results';
export const EMAIL_RESULTS_FAILED = 'email_results_failed';
export const NOTIFICATIONS = 'notifications';
export const NOTIFICATIONS_FAILED = 'notifications_failed';

export const TRACK_PAGE = 'track_page';
export const TRACK_PAGE_FAILED = 'track_page_failed';

export const COMPLETE_SASP_TEST = 'complete_sasp_test';
export const COMPLETE_SASP_TEST_FAIL = 'complete_sasp_test_fail';

export const PERSISTANT_LOGIN = 'persistant_login';
export const PERSISTANT_LOGIN_FAIL = 'persistant_login_fail';

export const PREV_PAGE_DATA = 'prev_page_data';
export const PREV_PAGE_DATA_FAILED = 'prev_page_data_failed';

export const REMOVE_QUESTION_FROM_DECK = 'remove_question_from_deck';
export const REMOVE_QUESTION_FROM_DECK_FAILED = 'remove_question_from_deck_failed';

export const DAILY_USER = 'daily_user';
export const DAILY_USER_FAIL = 'daily_user_fail';

export const GET_FLASH_CARDS = "get_flash_cards";
export const GET_FLASH_CARDS_FAILED = "get_flash_cards_failed";

export const GET_FLASH_CARD = "get_flash_card";
export const GET_FLASH_CARD_FAILED = "get_flash_card_failed";

export const RATE_APP = "rate_app";
export const RATE_APP_FAILED = "rate_app_failed";

export const GET_PRE_MADE = 'get_pre_made';
export const GET_PRE_MADE_FAILED = 'get_pre_made_failed';

export const SEND_MESSAGE = 'send_message';
export const SEND_MESSAGE_FAILED = 'send_message_failed';

export const GET_MESSAGES = 'get_messages';
export const GET_MESSAGES_FAILED = 'get_messages_failed';

export const GET_RESIDENCY_PROGRAM = 'get_residency_program';
export const GET_RESIDENCY_PROGRAM_FAILED = 'get_residency_program_failed';

export const GET_RESIDENT_DATA = 'get_resident_data';
export const GET_RESIDENT_DATA_FAILED = 'get_resident_data_failed';

export const GET_QUIZZES_RESULTS_DATA = 'get_quizzes_results_data';
export const GET_QUIZZES_RESULTS_DATA_FAILED = 'get_quizzes_results_data_failed';

export const GET_QUIZZES_RESULTS_LIST_DATA = 'get_quizzes_results_list_data';
export const GET_QUIZZES_RESULTS_LIST_DATA_FAILED = 'get_quizzes_results_list_data_failed';

export const GET_QUIZZES_RESULTS_LIST_ALL_DATA = 'get_quizzes_results_list_all_data';
export const GET_QUIZZES_RESULTS_LIST_ALL_DATA_FAILED = 'get_quizzes_results_list_all_data_failed';

export const GET_QUIZZES_DATA = 'get_quizzes_data';
export const GET_QUIZZES_DATA_FAILED = 'get_quizzes_data_failed';

export const GET_PROGRAM_QUIZZES_DATA = 'get_program_quizzes_data';
export const GET_PROGRAM_QUIZZES_DATA_FAILED = 'get_program_quizzes_data_failed';

export const GET_LONG_QUIZZES_DATA = 'get_long_quizzes_data';
export const GET_LONG_QUIZZES_DATA_FAILED = 'get_long_quizzes_data_failed';

export const GET_QUIZ_DATA = 'get_quiz_data';
export const GET_QUIZ_DATA_FAILED = 'get_quiz_data_failed';

export const SAVE_QUIZ_DATA = 'save_quiz_data';
export const SAVE_QUIZ_DATA_ERROR = 'save_quiz_data_error';

export const SAVE_TEST_DATA = 'save_test_data';
export const SAVE_TEST_DATA_ERROR = 'save_test_data_error';

export const SASP_REPORT = 'sasp_report';
export const SASP_CME_YEARS = 'sasp_cme_years';